import React, { useContext, useEffect, useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
	CircularProgress,
	Box,
	Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalContext } from "../../GlobalContext";
import { getForecastFile, updateForecastFile } from "../../api/forecast.client";
import { auditPost } from "../../api/config";
import { useTranslation } from "react-i18next";
import ForecastStepTwo from "./ForecastStepTwo";

export default function EditForecastModal({ open, onClose, fileId, onSaved }) {
	const { site_id, getModuleId } = useContext(GlobalContext);
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (!open || !fileId) return;
		(async () => {
			setError(null);
			setData(null);
			try {
				const json = await getForecastFile({ site_id, file_id: fileId });

				if (json && json.message) {
					setError(json.message);
				} else {
					setData(json);
				}
			} catch (e) {
				setError(e?.message || "Error desconocido");
			}
		})();
	}, [open, fileId, site_id]);

	const handleSave = async (payload) => {
		try {
			await updateForecastFile({
				site_id,
				file_id: fileId,
				body: payload,
			});

			if (getModuleId) {
				const id = getModuleId("Forecast", "Actualizar un registro de demanda");

				if (id && site_id) auditPost(id, site_id);
			}
			onSaved?.();
			onClose?.();
		} catch (e) {
			alert(t("forecast.modal.errorUpdate", "Error al actualizar el forecast"));
		}
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			container={typeof window !== "undefined" ? document.body : undefined}
			keepMounted
			fullScreen={false}
			maxWidth={false}
			scroll="paper"
			PaperProps={{
				sx: {
					width: { xs: "95vw", md: "min(1200px, 95vw)" },
					maxWidth: "90vw",
					mx: "0",
					my: 0,
					borderRadius: 2,
					display: "flex",
					flexDirection: "column",
				},
			}}
			slotProps={{ backdrop: { sx: { backdropFilter: "blur(1px)" } } }}
		>
			<DialogTitle sx={{ pr: 6 }}>
				{t("forecast.modal.editTitle")}
				<IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 8, top: 8 }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent
				sx={{
					p: 2,
					display: "flex",
					flexDirection: "column",
					gap: 2,
					flex: 1,
					minHeight: 0,
					overflow: "auto",
				}}
			>
				{error ? (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				) : !data ? (
					<CircularProgress />
				) : (
					<Box
						sx={{
							flex: 1,
							minHeight: 0,
							display: "flex",
							flexDirection: "column",
							alignItems: "stretch",
						}}
					>
						<ForecastStepTwo data={data} mode="edit" selectedMonth={null} onSave={handleSave} />
					</Box>
				)}
			</DialogContent>
		</Dialog>
	);
}
